import * as v from 'valibot';

export const manageOfferingsSchema = v.object({
  offeringName: v.pipe(v.string(), v.minLength(1, 'Offering name is required')),
  displayNames: v.record(v.string(), v.string()),
});

export type ManageOfferingsFormValues = v.InferOutput<typeof manageOfferingsSchema>;
